/* Yes Vegan · CRO helpers · YV MASTER 2026
   0) GemPages-"In den Warenkorb" → Ajax + Cart Drawer statt Weiterleitung auf /cart
   1) 1-Klick-Add für Routine-Cross-Sell, Gratis-Belohnungen und Academy-Produktkarten ([data-yv-add])
   2) Sticky CTA für GemPages-Produktseiten (#yv-sticky-cta)
   3) Academy-Newsletter (Klaviyo Client API, Double-Opt-in-Liste "Plant-Based Academy")
   4) Academy Inline-Bridge: kontextuelle Produktkarte im Blogartikel
*/
(function () {
  'use strict';
  if (window.__yvCro) return; window.__yvCro = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function openDrawer() {
    var d = document.getElementById('Cart-Drawer');
    if (!d) return;
    var om = (typeof OverlayManager !== 'undefined') ? OverlayManager : window.OverlayManager;
    if (om && om.open) { try { om.open(d); } catch (e) {} }
    else { var t = document.getElementById('cart-drawer-toggle'); if (t && d.hasAttribute('inert')) t.click(); }
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
  }

  function refreshDrawer(open) {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var parse = function (html, sel) { var d = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return d ? d.innerHTML : null; };
        var drawer = document.getElementById('Cart-Drawer');
        if (drawer && s['cart-drawer']) { var h = parse(s['cart-drawer'], '.cart-drawer'); if (h !== null) drawer.innerHTML = h; }
        var bubble = document.getElementById('cart-drawer-toggle');
        if (bubble && s['cart-bubble']) {
          var target = bubble.querySelector('.thb-item-count') || bubble;
          var b = parse(s['cart-bubble'], '.thb-item-count'); if (b !== null) target.innerHTML = b;
        }
        refreshCartBoost();
        if (open) {
          if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
          openDrawer();
        }
      });
  }
  window.yvRefreshDrawer = refreshDrawer;

  function refreshCartBoost() {
    var box = document.querySelector('[data-yv-cart-boost]');
    if (!box) return;
    var id = box.getAttribute('data-yv-cart-boost');
    fetch(location.pathname + '?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (!s[id]) return;
        var n = new DOMParser().parseFromString(s[id], 'text/html').querySelector('[data-yv-cart-boost]');
        if (n) box.innerHTML = n.innerHTML;
      }).catch(function () {});
  }
  document.addEventListener('line-item:change:end', function () { setTimeout(refreshCartBoost, 50); });

  /* 0) GemPages "In den Warenkorb" → Ajax + Cart Drawer statt Weiterleitung auf /cart */
  function addFromForm(form, btn) {
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) return false;
    var qty = 1;
    fd.getAll('quantity').forEach(function (q) { var n = parseInt(q, 10); if (n > 0) qty = n; });
    var item = { id: parseInt(id, 10), quantity: qty };
    var sp = fd.get('selling_plan'); if (sp) item.selling_plan = parseInt(sp, 10);
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') props[m[1]] = v; });
    if (Object.keys(props).length) item.properties = props;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshDrawer(true); })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Konnte nicht hinzugefügt werden.';
        if (btn) btn.insertAdjacentHTML('afterend', '<span class="yv-add-error" role="alert">' + String(msg).replace(/</g, '&lt;') + '</span>');
      })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
    return true;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gp-button-atc');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    if (!document.getElementById('Cart-Drawer')) return;
    var form = btn.closest('form') || (btn.form || null);
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (!addFromForm(form, btn)) form.submit();
  }, true);

  /* 1) Delegated add-to-cart */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-yv-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    var id = parseInt(btn.getAttribute('data-yv-add'), 10);
    if (!id) return;
    var item = { id: id, quantity: 1 };
    if (btn.hasAttribute('data-yv-gift')) item.properties = { _yv_gift: '1' };
    var label = btn.innerHTML;
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.textContent = '…';
    fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshDrawer(true); })
      .catch(function (err) {
        btn.innerHTML = label; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
        var msg = (err && (err.description || err.message)) || 'Konnte nicht hinzugefügt werden.';
        btn.insertAdjacentHTML('afterend', '<span class="yv-add-error" role="alert">' + String(msg).replace(/</g, '&lt;') + '</span>');
      });
  });

  /* 2) Sticky CTA (GemPages PDP) */
  function initSticky() {
    var bar = document.getElementById('yv-sticky-cta');
    if (!bar) return;
    var findTarget = function () {
      var list = document.querySelectorAll('.gp-button-atc, product-form button[name="add"], form[action*="/cart/add"] button[type="submit"]');
      for (var i = 0; i < list.length; i++) {
        var b = list[i];
        if (bar.contains(b) || b.closest('.cart-drawer') || b.closest('product-add-to-cart-sticky')) continue;
        if (b.offsetParent !== null) return b;
      }
      return null;
    };
    var target = findTarget();
    if (!target) return;
    var btn = bar.querySelector('.yv-sticky-cta__btn');
    var priceEl = bar.querySelector('.yv-sticky-cta__price');
    var prices = {};
    try { prices = JSON.parse(bar.getAttribute('data-prices') || '{}'); } catch (e) {}
    var money = function (cents) { return (cents / 100).toFixed(2).replace('.', ',') + '€'; };

    var syncVariant = function () {
      var form = target.closest('form') || document.querySelector('gp-product form, product-form form');
      var idInput = form && form.querySelector('input[name="id"], select[name="id"]');
      var vid = idInput && idInput.value;
      if (!vid) { try { vid = new URL(location.href).searchParams.get('variant'); } catch (e) {} }
      var p = vid && prices[vid];
      if (p) {
        priceEl.textContent = money(p.price);
        var soldOut = !p.available;
        btn.disabled = soldOut;
        btn.textContent = soldOut ? 'Ausverkauft' : 'In den Warenkorb';
      }
    };
    document.addEventListener('change', function () { setTimeout(syncVariant, 60); }, true);
    document.addEventListener('click', function (e) { if (e.target.closest('gp-product-variants, .gp-product-variants, variant-selects, [data-gp-variant], gp-product-variant')) setTimeout(syncVariant, 150); }, true);
    syncVariant();

    var visible = false;
    var setVisible = function (v) {
      if (v === visible) return; visible = v;
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      document.documentElement.classList.toggle('yv-sticky-on', v);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        setVisible(!en.isIntersecting && en.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(target);
    }
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var t = findTarget() || target;
      t.click();
    });
  }

  /* 3) Academy-Newsletter via Klaviyo Client API (Double-Opt-in) */
  function initAcademyForms() {
    document.querySelectorAll('form[data-yv-academy]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (form.querySelector('input[type="email"]') || {}).value || '';
        var consent = form.querySelector('input[name="consent"]');
        var status = form.querySelector('.yv-academy-form__status');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { status.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; return; }
        if (consent && !consent.checked) { status.textContent = 'Bitte bestätige kurz die Einwilligung.'; return; }
        var company = form.getAttribute('data-company');
        var listId = form.getAttribute('data-list');
        var source = form.getAttribute('data-source') || 'Academy Bridge';
        form.classList.add('is-loading');
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: { email: email, properties: { yv_academy_topic: form.getAttribute('data-topic') || '', yv_signup_page: location.pathname } } } }
          }, relationships: { list: { data: { type: 'list', id: listId } } } } })
        }).then(function (r) {
          form.classList.remove('is-loading');
          if (r.status === 202 || r.ok) {
            form.innerHTML = '<p class="yv-academy-form__ok"><strong>Fast geschafft!</strong> Bitte bestätige deine Anmeldung über den Link in deinem Postfach. Danach startet ' + (form.getAttribute('data-ok') || 'deine Academy-Serie') + '.</p>';
          } else { status.textContent = 'Das hat leider nicht geklappt. Bitte versuche es später erneut.'; }
        }).catch(function () { form.classList.remove('is-loading'); status.textContent = 'Verbindungsfehler – bitte später erneut versuchen.'; });
      });
    });
  }

  /* 4) Inline-Bridge im Artikel: Karte vor dem 4. Absatz einsetzen */
  function initInlineBridge() {
    var card = document.getElementById('yv-inline-bridge');
    if (!card) return;
    var content = document.querySelector('.article-content, .post-content, .blog-post-detail .rte, article .rte, .rte');
    if (!content) { card.remove(); return; }
    var paras = content.querySelectorAll(':scope > p, :scope > h2');
    var anchor = paras.length > 4 ? paras[3] : null;
    if (!anchor) { card.remove(); return; }
    anchor.parentNode.insertBefore(card, anchor);
    card.hidden = false;
  }

  /* 5) Back-in-Stock: Formular unter dem Kaufbutton, wenn gewählte Variante ausverkauft (Klaviyo Client API) */
  function initBackInStock() {
    var box = document.getElementById('yv-bis');
    var bar = document.getElementById('yv-sticky-cta');
    if (!box || !bar) return;
    var prices = {};
    try { prices = JSON.parse(bar.getAttribute('data-prices') || '{}'); } catch (e) {}
    var currentVid = function () {
      var inp = document.querySelector('gp-product form input[name="id"], form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      var vid = inp && inp.value;
      if (!vid) { try { vid = new URL(location.href).searchParams.get('variant'); } catch (e) {} }
      if (!vid) { var ks = Object.keys(prices); for (var i = 0; i < ks.length; i++) { if (prices[ks[i]].available) { vid = ks[i]; break; } } if (!vid) vid = ks[0]; }
      return vid;
    };
    var place = function () {
      var btn = document.querySelector('.gp-button-atc, form[action*="/cart/add"] button[type="submit"]');
      var host = btn && (btn.closest('form') || btn.closest('.gp-button-atc') || btn);
      if (host && host.parentNode && box.previousElementSibling !== host) host.parentNode.insertBefore(box, host.nextSibling);
    };
    var sync = function () {
      var vid = currentVid();
      var p = vid && prices[vid];
      var sold = !!(p && !p.available);
      box.hidden = !sold;
      box.setAttribute('data-variant', vid || '');
      if (sold) place();
    };
    document.addEventListener('change', function () { setTimeout(sync, 80); }, true);
    document.addEventListener('click', function (e) { if (e.target.closest('gp-product-variants, .gp-product-variants, variant-selects, [data-gp-variant], gp-product-variant')) setTimeout(sync, 180); }, true);
    sync();
    var form = box.querySelector('form[data-yv-bis]');
    var status = box.querySelector('.yv-bis__status');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (form.querySelector('input[type="email"]') || {}).value || '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { status.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; return; }
      var vid = box.getAttribute('data-variant');
      form.classList.add('is-loading');
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(form.getAttribute('data-company')), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } } } })
      }).then(function (r) {
        form.classList.remove('is-loading');
        if (r.status === 202 || r.ok) { form.remove(); status.innerHTML = '<strong>Eingetragen!</strong> Wir melden uns, sobald die Variante wieder verfügbar ist.'; }
        else { status.textContent = 'Das hat leider nicht geklappt. Bitte versuche es später erneut.'; }
      }).catch(function () { form.classList.remove('is-loading'); status.textContent = 'Verbindungsfehler – bitte später erneut versuchen.'; });
    });
  }

  function init() { initSticky(); initAcademyForms(); initInlineBridge(); initBackInStock(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
